import { render, staticRenderFns } from "./ReportTabV2.vue?vue&type=template&id=87a567a6&"
import script from "./ReportTabV2.vue?vue&type=script&lang=js&"
export * from "./ReportTabV2.vue?vue&type=script&lang=js&"
import style0 from "./ReportTabV2.vue?vue&type=style&index=0&id=87a567a6&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports